<mat-sidenav-container autosize>
    <mat-sidenav
        [disableClose]="true"
        [mode]="isMobile ? 'over' : 'side'"
        [opened]="true"
        [ngClass]="[
            !isCollapsed && isMobile ? '!shadow-2xl' : '',
            user?.isMasqueraded ? '!bg-error-50' : '',
        ]"
    >
        <div
            [ngClass]="
                isCollapsed
                    ? 'mt-1 ml-0.5'
                    : 'flex items-center justify-between space-x-1 pt-1 pl-0.5 pr-4'
            "
        >
            <button
                [ngClass]="
                    user?.isMasqueraded
                        ? 'masquerade-sidenav-button-highlight'
                        : 'sidenav-button-highlight'
                "
                mat-icon-button
                aria-label="Menu icon"
                (click)="toggleSidenav()"
            >
                <mat-icon>menu</mat-icon>
            </button>

            @if (!isCollapsed) {
                <span class="w-[198px]">
                    @if (isUserRoleCustomer()) {
                        <app-membership-chip
                            [user]="user"
                        ></app-membership-chip>
                    }
                </span>
            }
        </div>
        <mat-nav-list>
            @for (item of navigationIconLinks; track item) {
                <app-sidenav-item
                    [item]="item"
                    [isMember]="isMember()"
                    [isCollapsed]="isCollapsed"
                    [isCustomer]="isUserRoleCustomer()"
                ></app-sidenav-item>
            }
            <app-sidenav-bottom-panel
                [isCollapsed]="isCollapsed"
            ></app-sidenav-bottom-panel>
        </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content
        [ngClass]="isMobile || isCollapsed ? 'ml-[53px]' : ''"
        class="px-5 py-7 bg-neutral-50 mt-3"
    >
        <ng-content></ng-content>
    </mat-sidenav-content>
</mat-sidenav-container>
